import { render } from "./TaskView.vue?vue&type=template&id=d3ec2f98"
import script from "./TaskView.vue?vue&type=script&lang=js"
export * from "./TaskView.vue?vue&type=script&lang=js"

import "./TaskView.vue?vue&type=style&index=0&id=d3ec2f98&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/view/TaskView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d3ec2f98"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d3ec2f98', __exports__)) {
    api.reload('d3ec2f98', __exports__)
  }
  
  module.hot.accept("./TaskView.vue?vue&type=template&id=d3ec2f98", () => {
    api.rerender('d3ec2f98', render)
  })

}


export default __exports__